import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import LeadForm from "./LeadForm";

export default function LeadDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="lead-dialog"
        className="max-w-2xl bg-[#0A0A0A] border border-white/10 text-white rounded-none p-0 overflow-hidden"
      >
        <div className="p-8 md:p-10 max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <div className="eyebrow mb-3">Free Consultation</div>
            <DialogTitle className="font-serif text-3xl md:text-4xl leading-tight text-white font-light">
              Book your{" "}
              <span className="gold-gradient-text italic">Dholera</span> site
              visit
            </DialogTitle>
            <DialogDescription className="text-white/60 font-light mt-2">
              Share a few details and our senior advisor will reach out within
              the next business hour.
            </DialogDescription>
          </DialogHeader>
          <div className="mt-8">
            <LeadForm
              variant="dialog"
              testidPrefix="dialog-lead"
              onSuccess={() => onOpenChange(false)}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
